<template>
    <div class="zebra-crossing-detail">
        <!-- 处理明细 -->
        <el-form>
            <div class="zebra-item">
                <div class="zebra-item_tit">服务信息</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="状态：">{{ detail.status | tableVal(problemStatus) }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="指派人：">{{ detail.designator }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="当前处理人：">{{ detail.currentHandler }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="服务组：">{{ detail.currentDepartment }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="参与处理的人员：">
                            <span v-for="item in detail.participant" style="margin-right: 10px;">{{item}}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="创建人：">{{ detail.createUser }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="报告人：">{{ detail.requester }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="创建时间：">{{ detail.createTime }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="关闭时间：">{{ detail.closeTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="更新人：">{{ detail.updateUser }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="最后更新时间：">{{ detail.updateTime }}</el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            problemStatus(){
                return this.dictionary.problem_status;
            },
        },
        data() {
            return {}
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
